import { render, staticRenderFns } from "./FaceUpSingle.vue?vue&type=template&id=2ce8c018&"
import script from "./FaceUpSingle.vue?vue&type=script&lang=js&"
export * from "./FaceUpSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports